import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MtcGameSelectorComponent } from './mtc-game-selector/mtc-game-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { MtcGameCoreService } from './mtc-game-core.service';

@NgModule({
  declarations: [MtcGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [MtcGameCoreService],
  exports: [MtcGameSelectorComponent],
})
export class MtcGameCoreModule {}
